import axios from "axios";
import platformSettings from '~config/settings'
import store from "@/store/index"
import { hasSession, localStorageLabel } from "@/utils/helpers.js";
const $axios = axios.create({
    baseURL: platformSettings.apiHost
});

const sessions = Object.keys(sessionStorage)
const hasAuth = hasSession()
let tokens = {}
if (hasAuth) {
    const localStorageToken = localStorage.getItem(localStorageLabel()) || undefined
    const sessionJson = JSON.parse(sessionStorage[sessions.filter(e => e.startsWith('firebase:authUser'))[0]])
    const isExpired = sessionJson.stsTokenManager && sessionJson.stsTokenManager.expirationTime <= new Date().getTime() || false
    tokens = isExpired ? {} : sessionJson.stsTokenManager
    if (isExpired) {
        localStorage.removeItem(localStorageLabel())
    }
    if (localStorageToken === undefined && !isExpired) {
        localStorage.setItem(localStorageLabel(), JSON.stringify(sessionJson));
    }
}

$axios.interceptors.request.use( async request => {
    if (request.url.startsWith('/buyer/')) {
        return request
    }
    request.headers.Authorization = tokens.accessToken || await store.dispatch('user/fetchIdToken')
    return request;
}, error => {
    return Promise.reject(error)
})

$axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            store.commit('errors/setMessage', 'Sie haben keine Berechtigung, diese Aktion auszuführen.')
            store.commit('errors/setVisibility', true)
        }
        return Promise.reject(error)
    }
)

export default $axios;
